module.exports = __webpack_public_path__ + "img/site-logo.588577d9.svg";